import {useNavigation, useRoute} from '@react-navigation/native';
import React, {useEffect} from 'react';
import {Header} from '../../../components/Interface/Headers/Header';
import analytics from '@react-native-firebase/analytics';

import {
  Container,
  Content,
  Title,
  Text,
  TitleContent,
  ContentSection,
  Footer,
} from './styles';
import {HelpArticleDTO} from '../../../dtos/HelpArticleDTO';
import {RFValue} from 'react-native-responsive-fontsize';
import {SafeAreaView} from 'react-native-safe-area-context';
import {Button} from '../../../components/Interface/Forms/Buttons/Button';

interface Params {
  data: HelpArticleDTO;
}

export function HelpArticle() {
  const route = useRoute();
  const navigation = useNavigation();

  const {data} = route.params as Params;

  useEffect(() => {
    analytics().logEvent('tela_ajuda_artigos');
  }, []);

  return (
    <Container>
      <Header title="Ajuda" icon="chevron-left" action={() => navigation.navigate('Help')} />

      <Content
        contentContainerStyle={{paddingBottom: RFValue(20)}}
        showsVerticalScrollIndicator={true}>
        <Title>{data.title}</Title>
        <Text>{data.text}</Text>

        <ContentSection>
          {data.content &&
            data.content.map(item => (
              <>
                {item.title && <TitleContent>{item.title}</TitleContent>}
                {item.text && <Text>{item.text}</Text>}
              </>
            ))}
        </ContentSection>
      </Content>
      {data.buttonAction && data.buttonTitle && (
        <Footer>
          <SafeAreaView>
            <Button
              title={data.buttonTitle}
              enabled
              onPress={data.buttonAction}
            />
          </SafeAreaView>
        </Footer>
      )}
    </Container>
  );
}
